export const RESET_STATE = 'CRM_RESET_STATE';
export const CURRENT_ITEM = 'CRM_CURRENT_ITEM';

export const REQUEST_LOADING = 'CRM_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'CRM_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'CRM_REQUEST_FAILED';

export const CURRENT_ACTION = 'CRM_CURRENT_ACTION';
export const RESET_ACTION = 'CRM_RESET_ACTION';
